var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.ref ? 'router-link' : 'span',_vm._b({tag:"component",class:{'no-owner': !_vm.title}},'component',_vm.bind,false),[_vm._v(" "+_vm._s(_vm.title || '(no owner)')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }